import firebase from '@app/plugins/firebase'
import { checkLang } from '@app/utils/checkLang'

const auth = () => {
  return new Promise<{ user: firebase.User | null; isSignIn: boolean }>(
    (resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          resolve({
            user,
            isSignIn: true,
          })
        } else {
          resolve({
            user,
            isSignIn: false,
          })
        }

        unsubscribe()
        checkLang()
      })
    }
  )
}
export default auth
